import L from 'leaflet'

import url from '@/utils/url'
import { TILE_LAYER } from '@/config/map'
import layersMixin from '@/mixins/layers-mixin'
import { map as mapEndpoints } from '@/api/api-endpoints'
import { OBJECT_RENDERER } from '@/config/config'
import ObjectsSupeclasterLayerDrawer from '@/utils/map/superclaster/ObjectsSupeclasterLayerDrawer'
import BaseLayerDrawer from '@/utils/map/BaseLayerDrawer'
import measureMixin from '../mixins/measure-mixin'
import threadsMixin from '../mixins/threads-mixin'
import { REGION_CONFIG } from '@/config/regions'

const mapConfig = REGION_CONFIG.map

export default {
  data() {
    this.searchExactEndpoint = (id) => mapEndpoints.searchExact(id)
    this.mapLayers = null
    this.map = null
    this.mapEndpoints = []
    this.objectDrawer = null
    return {
      q: '',
      layers: [],
    }
  },
  mixins: [layersMixin, measureMixin, threadsMixin],
  created() {
    this.setFiltersFromUrl()
    let promises = []
    let usedRoute = url.getPrevOrCurrentRoute(this.$route)
    if (usedRoute?.query?.layers) {
      let conf = this.getParentsConf(
        usedRoute.query.layers.split(','),
        this.getLayersConf()
      )
      for (let key in conf) {
        const endpoint = this.getLayerEndpoint(conf, key, usedRoute)
        promises.push(
          this.$store.dispatch('updateUrlEndpoint', {
            endpoint,
            cache: false,
            notReactive: false,
          })
        )
      }
    }
    promises.push(
      this.$store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.heatMapRegOperators(
          this.$route.query.zoom || mapConfig.zoom
        ),
        cache: true,
        fromCache: true,
      })
    )

    return Promise.all(promises)
  },
  mounted() {
    this.$store.commit('preloaderOn', true)
  },
  computed: {
    userData() {
      return this.$store.getters?.userData || null
    },
    layerLegendItems() {
      if (!Object.keys(this.layerGroups).length) {
        return []
      }
      return this.layersWithData.filter((layer) => this.layerGroups[layer])
    },
    layerGroups() {
      return Object.assign(
        {},
        ...Object.values(this.getLayersConf()).map((lC) => lC.groups)
      )
    },
    module() {
      return 'geo'
    },
    mapBorders() {
      return null
    },
  },
  methods: {
    getCopyWithoutObservers(data) {
      return JSON.parse(JSON.stringify(data))
    },
    getMapConfigData() {
      return mapConfig
    },
    getMapPolygon() {
      return REGION_CONFIG.polygon
    },
    drawTiles() {
      L.tileLayer(TILE_LAYER).addTo(this.map)
    },
    getLayersConf() {
      return REGION_CONFIG.rightMenu
    },
    destroyMap() {
      this.$emitter.emit('geo.destroyMap', {})
      if (this.map) {
        this.map.remove()
        this.map = null
      }
    },
    async afterMapInit() {
      this.initObjectsLayerDrawer()
      this.objectDrawer = this.getObjectDrawer()
      await this.setDataToLayersFromStore()
    },
    initObjectsLayerDrawer() {
      if (OBJECT_RENDERER === 'superclaster') {
        this.objectsLayerDrawer = new ObjectsSupeclasterLayerDrawer(this.map, {
          vm: this,
        })
      } else {
        this.objectsLayerDrawer = new BaseLayerDrawer(this.map, { vm: this })
      }
      this.mapLayers = this.objectsLayerDrawer.setLayersConfigAndDraw(
        this.layersConf
      )
    },
    async onFormEvent(e) {
      if (e.action === 'onSaveForm' || e.action === 'onRemove') {
        if (this.objectsLayerDrawer) {
          this.objectsLayerDrawer.removeLayers()
        }

        this.$store.commit('deleteEndpoints', {
          endpoints: [mapEndpoints.objectCache()],
        })
        await this.reCreateMap()
      }
    },

    /**
     * Need for show changes after position of marker changed
     */
    async reCreateMap() {
      this.$store.commit('cleanCache')
      this.$store.commit('skipAsyncData', {
        name: `${this.module}.*`,
        depth: 1,
        value: false,
      })
      this.$bar.start().set(12)
      let params = { layers: this.layers }
      await this.replaceRoute(params, false)
      this.$bar.finish()
      this.afterReCreateMap()
      this.initObjectsLayerDrawer()
    },
    getParentsConf(layersArr, conf) {
      return layersMixin.methods.getParentsConf(layersArr, conf)
    },
    getLayerEndpoint(conf, type, route) {
      return layersMixin.methods.getLayerEndpoint(conf, type, route)
    },
    afterReCreateMap() {},
    getMOEndpoint() {
      return mapEndpoints.mo()
    },
  },
}
